function initEventList(block) {
    const tabs = Array.from(
        block.querySelectorAll(
            '[data-h3p-events-tab]'
        )
    );

    if (tabs.length === 0) {
        return;
    }

    function activateTab(nextTab) {
        tabs.forEach((tab) => {
            const isActive = tab === nextTab;
            const panelId = tab.getAttribute(
                'aria-controls'
            );
            const panel = panelId
                ? document.getElementById(panelId)
                : null;

            tab.classList.toggle(
                'is-active',
                isActive
            );

            tab.setAttribute(
                'aria-selected',
                String(isActive)
            );

            tab.tabIndex = isActive
                ? 0
                : -1;

            if (panel) {
                panel.hidden = !isActive;
            }
        });
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener(
            'click',
            () => activateTab(tab)
        );

        tab.addEventListener(
            'keydown',
            (event) => {
                const supportedKeys = [
                    'ArrowLeft',
                    'ArrowRight',
                    'Home',
                    'End',
                ];

                if (
                    !supportedKeys.includes(
                        event.key
                    )
                ) {
                    return;
                }

                event.preventDefault();

                let nextIndex = index;

                if (
                    event.key === 'ArrowRight'
                ) {
                    nextIndex =
                        (index + 1) % tabs.length;
                }

                if (
                    event.key === 'ArrowLeft'
                ) {
                    nextIndex =
                        (
                            index
                            - 1
                            + tabs.length
                        ) % tabs.length;
                }

                if (event.key === 'Home') {
                    nextIndex = 0;
                }

                if (event.key === 'End') {
                    nextIndex =
                        tabs.length - 1;
                }

                activateTab(
                    tabs[nextIndex]
                );

                tabs[nextIndex].focus();
            }
        );
    });
}

document.addEventListener(
    'DOMContentLoaded',
    () => {
        document
            .querySelectorAll(
                '.wp-block-h3p-liste-evenements'
            )
            .forEach(initEventList);
    }
);
